import React, { Component } from "react";
import "./dashboard.css";


import EACalculatorOnly from "./ea-calculator-only";
import EFS from "./efs";
import VONBOARDER from "./vonboard";
import REVIEWADMINLAYOUT from "./parts/review-admin/ReviewAdminLayout";
import MORTGAGE_BROKER from "./mortgagebroker";
import RSO from "./rso";
import axios from "axios";
import { Skeleton } from "antd";
import AM from "./am";
import Cookies from "js-cookie";
import EaDashboard from "./EaDashboards";
import { BOBREVIEWADMIN, SUPER_ADMIN } from "../../utils/Constants";
import VONBOARDEROLD from "./vonboard-back";
import VONBOARDADMIN from "./vonboard-admin";
import REVIEWSCHEDULER from "./reviewscheduler";
import REVIEWADMIN from "./reviewscheduler-admin";
import LSP from "./lsp";
import EA from "./ea";
import AMDashboard from "./AMDashboard";
import { useBoundStore } from "../../store/useBoundStore";


class Dashboard extends Component {
  state = {
    loading: false,
    calculator_only: false,
  };
  componentDidMount = () => {
    this.props.auth.refresh();

    if (this.props.auth.user.user_type === "EA") {
      this.setState({
        loading: true,
      });
      let user = useBoundStore.getState().userInfo;
      if (!user) {
        axios.get("/api/user").then((res) => {
          const user = res.data;
          // update user info after switch and render dashboard
          useBoundStore.getState().setUserInfo(user)
          this.setState({
            loading: false,
          });

          let CokkeeData =
            typeof Cookies.get("user_info") !== "undefined"
              ? JSON.parse(Cookies.get("user_info"))
              : {};

          let temp = {
            ...CokkeeData,
            agency_id: res.data.user_agency_assoc
              ? res.data.user_agency_assoc[0]
                ? res.data.user_agency_assoc[0].agency_id
                : null
              : null,
          };

          Cookies.set("user_info", JSON.stringify(temp), {
            secure: true,           //  HTTPS only
            sameSite: 'Lax',        // Add this — fixes the scan finding
            path: '/',              // explicit path
          });

          if (user.user_agency_assoc.length > 0) {
            var agency_id = user.user_agency_assoc[0].agency_id;
            axios.get("/api/agencies/" + agency_id).then((res) => {
              if (res.data.calculator_only == 1) {
                this.setState({
                  calculator_only: true,
                });
              }
            });
          }
        });
      } else {
        // axios.get("/api/user").then((res) => {
        // const user = res.data;
        // update user info after switch and render dashboard
        // useBoundStore.getState().setUserInfo(user)
        this.setState({
          loading: false,
        });

        let CokkeeData =
          typeof Cookies.get("user_info") !== "undefined"
            ? JSON.parse(Cookies.get("user_info"))
            : {};

        let temp = {
          ...CokkeeData,
          agency_id: user.user_agency_assoc
            ? user.user_agency_assoc[0]
              ? user.user_agency_assoc[0].agency_id
              : null
            : null,
        };

        Cookies.set("user_info", JSON.stringify(temp), {
          secure: true,           //  HTTPS only
          sameSite: 'Lax',        // Add this — fixes the scan finding
          path: '/',              // explicit path
        });
        // console.log("user",user.user_agency_assoc)

        if (user.user_agency_assoc.length > 0) {
          var agency_id = user.user_agency_assoc[0].agency_id;
          axios.get("/api/agencies/" + agency_id).then((res) => {
            if (res.data.calculator_only == 1) {
              this.setState({
                calculator_only: true,
              });
            }
          });
        }
        // });
      }
    }
  };

  // shouldComponentUpdate(nextProps, nextState) {
  //   return this.state.calculator_only !== nextState.calculator_only;
  // }

  render() {
    const { user } = this.props.auth;
    const { location } = this.props.history;

    if (this.state.loading) {
      return <Skeleton active />;
    }

    if (
      user.id === 2 ||
      user.user_type === SUPER_ADMIN ||
      user.user_type == BOBREVIEWADMIN ||
      (location.state &&
        location.state.user_type &&
        location.state.user_type === "BOBADMIN")
    ) {
      return <REVIEWADMINLAYOUT {...this.props} />
      //return <VONBOARDADMIN {...this.props} />;
    }

    if (user.user_type === "EA" && !this.state.calculator_only) {
      return <EaDashboard {...this.props} />;
      // return <EA {...this.props} />;
    }

    if (user.user_type === "EA" && this.state.calculator_only) {
      return <EACalculatorOnly {...this.props} />;
    }

    if (user.user_type === "EFS") {
      return <EFS {...this.props} />;
    }

    if (user.user_type === "LSP") {
      return <EaDashboard {...this.props} />;
      // return <LSP {...this.props} />;
    }

    // this is check for FollowUp-specialist (FS)
    if (user.user_type === "VONBOARDER") {
      // return <VONBOARDEROLD {...this.props} />;
      return <VONBOARDER {...this.props} />;
    }

    if (user.user_type === "REVIEWSCHEDULER") {
      // return <REVIEWSCHEDULER {...this.props} />;
      return <VONBOARDER {...this.props} />;
    }


    if (user.user_type === "VONSCHEDULER") {
      return <VONBOARDER {...this.props} />;
    }

    if (
      user.user_type === "REVIEWADMIN" ||
      user.user_type === SUPER_ADMIN ||
      user.user_type === BOBREVIEWADMIN ||
      (location.state &&
        location.state.user_type &&
        location.state.user_type === "REVIEWADMIN")
    ) {
      return <REVIEWADMINLAYOUT {...this.props} />
      // return <REVIEWADMIN {...this.props} />;
    }

    if (user.user_type === "MORTGAGE_BROKER") {
      return <MORTGAGE_BROKER {...this.props} />;
    }

    if (user.user_type === "RSO") {
      return <RSO {...this.props} />;
    }

    if (user.user_type === "AGENCY_MANAGER") {
      // Agency manager Dashboard  new 
      // return <AM {...this.props} />;
      return <AMDashboard {...this.props} />;
    }

    //  user type  added  BOBREVIEWADMIN and menu is RSFS_Admin
    if (user.user_type === "BOBREVIEWADMIN") {
      return <REVIEWADMINLAYOUT {...this.props} />
    }

    // user type added user type VONSCHEDULER and dashboard use REVIEWSCHEDULER
    // dashobard would be new VONBOARDER Dashboad we used in VONSCHEDULER
    if (user.user_type === "VONSCHEDULER") {
      // return <REVIEWSCHEDULER {...this.props} />
      return <VONBOARDER {...this.props} />;

    }

    if (user.user_type === "BOBREVIEWADMIN") {
      return <REVIEWADMINLAYOUT {...this.props} />
    }

    return <div>Something Wrong</div>;
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/index.js